import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const TampilInformasiToko = () => {
  const { user, dispatch } = useContext(AuthContext);
  const [form, setForm] = useState({
    namaToko: "",
    tagline: "",
    alamat: "",
    nomorWhatsapp: "",
    email: "",
    namaRekening: "",
    bank: "",
    nomorRekening: "",
    warningTransfer: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getInformasiToko = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${tempUrl}/informasiToko`, {
          _id: user.id,
          token: user.token,
        });
        setForm({
          namaToko: response.data.namaToko || "",
          tagline: response.data.tagline || "",
          alamat: response.data.alamat || "",
          nomorWhatsapp: response.data.nomorWhatsapp || "",
          email: response.data.email || "",
          namaRekening: response.data.namaRekening || "",
          bank: response.data.bank || "",
          nomorRekening: response.data.nomorRekening || "",
          warningTransfer: response.data.warningTransfer || "",
        });
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
        }
        setError(err.response?.data?.message || "Gagal mengambil informasi toko.");
      }
      setLoading(false);
    };

    getInformasiToko();
  }, [dispatch, user.id, user.token]);

  const updateField = (field, value) => {
    setForm((current) => ({
      ...current,
      [field]: value,
    }));
  };

  const saveInformasiToko = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await axios.post(`${tempUrl}/updateInformasiToko`, {
        ...form,
        _id: user.id,
        token: user.token,
      });
      setSuccess("Informasi toko berhasil disimpan.");
    } catch (err) {
      if (err.response?.status === 401) {
        dispatch({ type: "LOGOUT" });
      }
      setError(err.response?.data?.message || "Gagal menyimpan informasi toko.");
    }

    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Master</div>
          <h1 className="page-title">Informasi Toko</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}
        <Form onSubmit={saveInformasiToko}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nama Toko</Form.Label>
                <Form.Control value={form.namaToko} onChange={(e) => updateField("namaToko", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Tagline</Form.Label>
                <Form.Control value={form.tagline} onChange={(e) => updateField("tagline", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Alamat</Form.Label>
                <Form.Control as="textarea" rows={4} value={form.alamat} onChange={(e) => updateField("alamat", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nomor WhatsApp</Form.Label>
                <Form.Control value={form.nomorWhatsapp} onChange={(e) => updateField("nomorWhatsapp", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control value={form.email} onChange={(e) => updateField("email", e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Bank</Form.Label>
                <Form.Control value={form.bank} onChange={(e) => updateField("bank", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nomor Rekening</Form.Label>
                <Form.Control value={form.nomorRekening} onChange={(e) => updateField("nomorRekening", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nama Rekening</Form.Label>
                <Form.Control value={form.namaRekening} onChange={(e) => updateField("namaRekening", e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Warning Transfer</Form.Label>
                <Form.Control as="textarea" rows={5} value={form.warningTransfer} onChange={(e) => updateField("warningTransfer", e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
          <div className="form-actions mt-3">
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default TampilInformasiToko;
